import { watchlistIdVar } from 'apollo/cache';

export const watchlistNotFound = `Insufficient permissions to view watchlist ID ${watchlistIdVar()}.
  Please check the ID or log into another organization, or reach out to support@veritone.com for further assistance.`;

export const noAccessInOrg = `Insufficient permissions to view watchlist ID ${watchlistIdVar()}.
  Please check the ID or navigate to another watchlist in this organization, or reach out to support@veritone.com for further assistance.`;
